module.exports = __webpack_public_path__ + "74fb036dfb7d98e25bd53d631fdc73b0.jpg";